import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-products-page',
    templateUrl: './products-page.component.html',
    styleUrls: ['./products-page.component.scss']
})
export class ProductsPageComponent implements OnInit {

    products = [
        {
            name: 'Interactive Flat Panels (IFP)',
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/AzHBLbJAym1cNKq1uPAK9Aer0UwoOvZsdmtCzLHV.jpg',
            highlights: [
                'Smart Touch 4K Display',
                'Android + Windows Dual OS',
                'Classroom-ready collaboration features'
            ],
            link: '/interactive-flat-panel-smart-classroom'
        },
        {
            name: 'IFP Protection (Shutter)',
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/fVxptF9b35oseaJ83BXjOEG7ltWb24One84GLDK4.jpg',
            highlights: [
                'Secure sliding cover for panels',
                'Protects screen from damage',
            ],
            link: '/shutter-system'
        },
        {
            name: 'All-in-One PCs',
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/DX5KLrFNJnGzkV3pyUEVmHCGo8W5qpVQQaWRFWLR.jpg',
            highlights: [
                'Compact, space-saving design',
                'High-performance processors',
            ],
            link: '/all-in-one-pc-computers-accessories'
        },
        {
            name: 'LMS Platform',
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/MYN9DZgKhN1rsxlXKVNieqFNeXU9ZXYn5vf2HWxD.jpg',
            highlights: [
                'Attendance, Homework, Assessments',
                'Teacher Dashboard',
                'Parent App + AI Analytics'
            ],
            link: '/lms'
        },
        {
            name: 'K-12 Digital Content',
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/e7JfR9nxK33xojuTA23L5BmBvxLBByRfzRJp3raN.jpg',
            highlights: [
                'NCERT-aligned curriculum',
                'Animated concept videos',
                'Assessments & worksheets'
            ],
            link: '/k-12-digital-content'
        },
        {
            name: 'Digital E-Library',
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/QTzghJRcvn6kGpobxiSqtr5rObdRg6AyVkuoV9zY.jpg',
            highlights: [
                'Interactive Storybooks & e-Books',
                'Audio & Video Content',
                'Thematic Reading Collections'
            ],
            link: '/digital-e-library'
        }
    ];

    constructor() { }

    ngOnInit(): void {
    }

}
